import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Register.css"; // ✅ Reusing same styling

export default function EmployeeRegister() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    position: "",
    location: "",
    referral: "",
    password: "",
  });

  const [errors, setErrors] = useState({});

  // Validation regex
  const regex = {
    name: /^[A-Za-z\s]{2,40}$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    mobile: /^[6-9]\d{9}$/,
    password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/,
  };

  const validate = () => {
    const newErrors = {};
    if (!regex.name.test(formData.name)) newErrors.name = "Enter a valid name.";
    if (!regex.email.test(formData.email)) newErrors.email = "Enter a valid email.";
    if (!regex.mobile.test(formData.mobile)) newErrors.mobile = "Enter a valid 10-digit mobile number.";
    if (!formData.position.trim()) newErrors.position = "Position is required.";
    if (!formData.location.trim()) newErrors.location = "Location is required.";
    if (!regex.password.test(formData.password))
      newErrors.password = "Password must be 6+ chars with letters & numbers.";
    return newErrors;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const res = await axios.post(
        `https://devskillz-ifm6.onrender.com/api/employee/register`,
        formData
      );

      if (res.data.message) {
        alert("Employee Registered Successfully!");
        navigate("/EmployeeLogin");
      }
    } catch (err) {
      alert(err.response?.data?.error || "❌ Server error. Please try again.");
    }
  };

  return (
    <div className="register-page">
      <div className="register-box">
        <h2>Employee Registration</h2>
        <p className="subtitle">Create your employee account</p>

        <form onSubmit={handleRegister} className="register-form">
          <div className="form-grid">

            <div>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && <p className="error">{errors.name}</p>}
            </div>

            <div>
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <p className="error">{errors.email}</p>}
            </div>

            <div>
              <input
                type="tel"
                name="mobile"
                placeholder="Mobile Number"
                value={formData.mobile}
                onChange={handleChange}
              />
              {errors.mobile && <p className="error">{errors.mobile}</p>}
            </div>

            <div>
              <input
                type="text"
                name="position"
                placeholder="Position (e.g., Coordinator)"
                value={formData.position}
                onChange={handleChange}
              />
              {errors.position && <p className="error">{errors.position}</p>}
            </div>

            <div>
              <input
                type="text"
                name="location"
                placeholder="Location (e.g., Hyderabad)"
                value={formData.location}
                onChange={handleChange}
              />
              {errors.location && <p className="error">{errors.location}</p>}
            </div>

            <div>
              <input
                type="text"
                name="referral"
                placeholder="Referral Code (optional)"
                value={formData.referral}
                onChange={handleChange}
              />
            </div>

            <div>
              <input
                type="password"
                name="password"
                placeholder="Set Password"
                value={formData.password}
                onChange={handleChange}
              />
              {errors.password && <p className="error">{errors.password}</p>}
            </div>

          </div>

          <button type="submit" className="submit-btn">Register</button>

          <div className="login-redirect">
            Already have an account?{" "}
            <span
              onClick={() => navigate("/EmployeeLogin")}
              className="login-link"
            >
              Login
            </span>
          </div>
        </form>
      </div>
    </div>
  );
}
